import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

export const IconWithOverlay = ({ children }: PropsWithChildren) => {
  return <IconContainer>{children}</IconContainer>;
};

const IconContainer = styled.div`
  position: relative;
  height: 18px;
  width: 24px;

  & > div::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      rgba(255, 255, 255, 0.7) 0%,
      rgba(0, 0, 0, 0.3) 100%
    );
    background-blend-mode: overlay;
    mix-blend-mode: overlay;
    z-index: 2;
    border-radius: 2px;
    background-size: 100% 99%;
  }
`;
